const CoreActionTakenOrNotTaken = ["Yes", "No", "All"];

export const ACTION_TAKEN = CoreActionTakenOrNotTaken;
